// extracted by mini-css-extract-plugin
export default {"container":"ProjectContainer_container__EBx2x","pulse":"ProjectContainer_pulse__l66dL"};